export default "__VITE_ASSET__BW$kE2El__"